import { apiService } from './api.service';
import { ENDPOINTS, STORAGE_KEYS } from '../config/api';
import { LoginCredentials, RegisterData, AuthToken, User } from '../types';

class AuthService {
  async login(credentials: LoginCredentials): Promise<AuthToken> {
    const formData = new URLSearchParams();
    formData.append('username', credentials.email);
    formData.append('password', credentials.password);

    const token = await apiService.post<AuthToken>(ENDPOINTS.LOGIN, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    this.setToken(token.access_token);
    return token;
  }

  async register(data: RegisterData): Promise<User> {
    const user = await apiService.post<User>(ENDPOINTS.REGISTER, data);
    return user;
  }

  logout(): void {
    localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
    localStorage.removeItem(STORAGE_KEYS.USER);
    window.location.href = '/login';
  }

  setToken(token: string): void {
    localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, token);
  }

  getToken(): string | null {
    return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
  }

  isAuthenticated(): boolean {
    return !!this.getToken();
  }

  async getCurrentUser(): Promise<User> {
    return apiService.get<User>(ENDPOINTS.ME);
  }
}

export const authService = new AuthService();
